import React, { useState } from 'react';
import { useSelector } from "react-redux";
import TabsItemOne from './TabsItemOne';
import TabsItemDropList from './TabsItemDropList';

const AsideMenuNav = ({item, eqv, setEqv, setIsOpenAside}) => {
    const [isOpenWebhook, setIsOpenWebhook] = useState(false)
    const [isOpenSpam, setIsOpenSpam] = useState(false)
    const [isOpenVerification, setIsOpenVerification] = useState(false)
    const [isOpenNuke, setIsOpenNuke] = useState(false)
    const [isOpenRaid, setIsOpenRaid] = useState(false)
    const [isOpenDetection, setIsOpenDetection] = useState(false)
    const { overviewGlobalState } = useSelector(state => state.overview)
    const { verificationRulesGlobalState } = useSelector(state => state.verification)
    const {verificationMessageGlobalState} = useSelector(state => state.verification)

    const hendlerOpenWebhook = () =>{
        
        if(!isOpenWebhook){
            setIsOpenWebhook(true)
            setIsOpenSpam(false)
            setIsOpenVerification(false)
            setIsOpenNuke(false)
            setIsOpenRaid(false)
            setIsOpenDetection(false)
            
        } else{
            setIsOpenWebhook(false)
        }
    }
    const hendlerOpenSpam = () =>{
        if(!isOpenSpam){
            setIsOpenSpam(true)
            setIsOpenWebhook(false)
            setIsOpenVerification(false)
            setIsOpenRaid(false)
            setIsOpenNuke(false)
            setIsOpenDetection(false)
        } else{
            setIsOpenSpam(false)
        }
    }
    const hendlerOpenVerification = () =>{
        if(!isOpenVerification){
            setIsOpenVerification(true)
            setIsOpenWebhook(false)
            setIsOpenSpam(false)
            setIsOpenRaid(false)
            setIsOpenNuke(false)
            setIsOpenDetection(false)
        } else{
            setIsOpenVerification(false)
        }
    }
    const hendlerOpenNuke = () =>{
        if(!isOpenNuke){
            setIsOpenVerification(false)
            setIsOpenWebhook(false)
            setIsOpenSpam(false)
            setIsOpenRaid(false)
            setIsOpenNuke(true)
            setIsOpenDetection(false)
        } else{
            setIsOpenNuke(false)
        }
    }
    const hendlerOpenDetection = () =>{
        if(!isOpenDetection){
            setIsOpenVerification(false)
            setIsOpenWebhook(false)
            setIsOpenSpam(false)
            setIsOpenRaid(false)
            setIsOpenNuke(false)
            setIsOpenDetection(true)
        } else{
            setIsOpenDetection(false)
        }
    }
    const hendlerOpenRaid = () =>{
        if(!isOpenRaid){
            setIsOpenVerification(false)
            setIsOpenWebhook(false)
            setIsOpenSpam(false)
            setIsOpenRaid(true)
            setIsOpenNuke(false)
            setIsOpenDetection(false)
        } else{
            setIsOpenRaid(false)
        }
    }

    return (
        <nav>
            <TabsItemOne
            title='Overview'
            subTitle='Overview'
            eqv={eqv}
            setEqv={setEqv}
            setIsOpenAside={setIsOpenAside}
            />
            <TabsItemOne
            title='Settings'
            subTitle='Settings'
            eqv={eqv}
            setEqv={setEqv}
            setIsOpenAside={setIsOpenAside}
            />
            <TabsItemOne
            title='Premium'
            subTitle='Premium'
            eqv={eqv}
            setEqv={setEqv}
            setIsOpenAside={setIsOpenAside}
            />
            <TabsItemOne
            title='Logging'
            subTitle='Logging'
            eqv={eqv}
            setEqv={setEqv}
            setIsOpenAside={setIsOpenAside}
            />
            <TabsItemDropList
            title='Anti-Webhook'
            subTitle='Anti-Webhook'
            eqv={eqv}
            setEqv={setEqv}
            hendlerOpen={hendlerOpenWebhook}
            isOpen={isOpenWebhook}
            setIsOpen={setIsOpenWebhook}
            setIsOpenAside={setIsOpenAside}
            isToggle={overviewGlobalState?.data?.anti_webhook}
            />
            <TabsItemDropList
            title='Anti-Spam'
            subTitle='Anti-Spam'
            eqv={eqv}
            setEqv={setEqv}
            hendlerOpen={hendlerOpenSpam}
            isOpen={isOpenSpam}
            setIsOpen={setIsOpenSpam}
                setIsOpenAside={setIsOpenAside}
                isToggle={overviewGlobalState?.data?.anti_spam}
            />
            <TabsItemDropList
            title='Verification'
            subTitle='Verification'
            eqv={eqv}
            setEqv={setEqv}
            hendlerOpen={hendlerOpenVerification}
            isOpen={isOpenVerification}
            setIsOpen={setIsOpenVerification}
                setIsOpenAside={setIsOpenAside}
                isToggle={overviewGlobalState?.data?.verification}
                isToggleRules={verificationRulesGlobalState?.data?.sendRules}
                isToggleMessage={verificationMessageGlobalState?.data?.sendMessage}
            />
            <TabsItemDropList
            title='Anti-Nuke'
            subTitle='Anti-Nuke'
            eqv={eqv}
            setEqv={setEqv}
            isOpen={isOpenNuke}
            hendlerOpen={hendlerOpenNuke}
            setIsOpen={setIsOpenNuke}
                setIsOpenAside={setIsOpenAside}
                isToggle={overviewGlobalState?.data?.anti_nuke}
            />
            <TabsItemDropList
            title='Fake Detection'
            subTitle='Fake Detection'
            eqv={eqv}
            setEqv={setEqv}
            isOpen={isOpenDetection}
            hendlerOpen={hendlerOpenDetection}
            setIsOpen={setIsOpenDetection}
                setIsOpenAside={setIsOpenAside}
                isToggle={overviewGlobalState?.data?.fake_detection}
            />
            <TabsItemDropList
            title='Anti-Raid'
            subTitle='Anti-Raid'
            eqv={eqv}
            setEqv={setEqv}
            hendlerOpen={hendlerOpenRaid}
            isOpen={isOpenRaid}
            setIsOpen={setIsOpenRaid}
                setIsOpenAside={setIsOpenAside}
                isToggle={overviewGlobalState?.data?.anti_raid}
            />

        </nav>
    );
};

export default AsideMenuNav;